var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',[_vm._l((_vm.block.attrs.elements),function(element,i){return _c('li',{key:i,domProps:{"innerHTML":_vm._s(element)}})}),(_vm.block.innerBlocks)?_c('RenderBlocks',{attrs:{"blocks":_vm.block.innerBlocks,"parentBlock":_vm.block}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }